import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import color from '@deprecated-ui/_style/color';
import device from '@deprecated-ui/_style/device';
import Image from 'global/Image';
import styled, { css } from 'styled-components';

interface ImgWrapperProps {
  height: string;
}

interface BadgeJunkProps {
  type: 'junk' | 'spam';
  visible: boolean;
}

const OptionItemContainer = styled(Flex).attrs({
  mb: '16px',
})`
  cursor: pointer;
  align-items: normal;
`;

// Label pro

const FlagPro = styled(Text).attrs({ as: 'a' })`
  color: ${color.suvaGrey};
  font-size: 10px;
  padding: 2px 3px;
  margin-left: 6px;
  border: 1px solid ${color.gainsboro};
  border-radius: 3px;

  :hover {
    color: unset;
  }
`;

/**
 *
 *  Stream Header Area
 *
 */

const HeaderContent = styled(Flex).attrs({ justify: 'space-between' })`
  width: 100%;
  position: relative;
  margin-left: 10px;

  @media ${device.tablet} {
    margin-left: 20px;
  }
`;
const TextHeader = styled(Text).attrs({ as: 'a' })`
  &:hover {
    color: inherit;
  }

  ${({ color: textColor }) =>
    textColor &&
    css`
      &:hover {
        color: ${textColor};
      }
    `}
`;
const Title = styled(Text).attrs({ as: 'a' })`
  color: ${color.primary};

  mark {
    background-color: #ff0;
  }
`;

/**
 * Stream component container
 */

const TextContainer = styled.div`
  margin-bottom: 16px;
`;

const ImgContainer = styled.div`
  margin-bottom: 16px;
`;

const FooterContainer = styled.div`
  position: relative;
  margin-bottom: 0px;
  margin-top: 15px;

  a.likes-info {
    color: #858585;
    font-size: 12px;
  }
  a.likes-info:hover {
    color: unset;
  }
`;

const StreamBoxContainer = styled.div`
  border-bottom: solid 1px ${color.gainsboro};
  padding: 20px 19px;
  &:last-of-type {
    border-bottom: none;
  }
`;

const NotifText = styled(Text).attrs({
  color: color.primary,
})`
  display: none;
  margin-left: 5px;
  @media ${device.tablet} {
    display: block;
  }
`;

/**
 *
 *  Stream Content Image Area
 *
 */

const ContentWrapper = styled.div`
  @media ${device.tablet} {
    margin-left: 70px;
  }
`;

const ImgModal = styled(Image)`
  max-height: 70vh;
  max-width: 70vw;
`;

const ImgWrapper = styled.div.attrs<ImgWrapperProps>((props) => ({
  height: props.height || '300px',
}))<ImgWrapperProps>`
  height: ${({ height }) => height};
  position: relative;
  width: 100%;
`;

const ImgContent = styled(Image)`
  cursor: pointer;
  height: 100%;
  left: 0;
  object-position: center;
  object-fit: cover;
  /* position: absolute; */
  top: 0;
  width: 100%;
`;

/**
 * Comment / Last reply
 */

const CommentContainer = styled(ContentWrapper)`
  padding: 15px;
  background: ${color.component};
  border-radius: 3px;
  margin-top: 20px;
`;

/**
 * Repost box
 */

const RepostBoxContainer = styled.div`
  border: solid 1px ${color.downgray};
  margin-top: 16px;
  padding: 12px;
  border-radius: 3px;
  cursor: pointer;
`;

const StreamOptionContainer = styled.div`
  padding: 16px;
  border: 1px solid ${color.downgray};
  border-radius: 3px;
  width: 280px;
  box-shadow: 0 1px 8px 1px rgb(0 0 0 / 6%) !important;

  & > :last-child {
    margin-bottom: 0px !important;
  }
`;

const StreamOptionDivider = styled.div`
  height: 1px;
  background: #f1f1f1;
  margin-bottom: 16px;
`;

const YoutubeWrapper = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

const RepostImageContainer = styled.div`
  margin-bottom: 10px;
`;

const FollowingActivityAvatar = styled.div`
  position: relative;
  height: 20px;
  min-width: 30px;
`;

const FollowingActivityAvatarItem = styled.div`
  position: absolute;

  img {
    width: 22px !important;
    height: 22px !important;
    border-radius: 50%;
    border: 2px solid ${color.light};
  }
`;

const BadgeJunkWrapper = styled(Flex)`
  position: relative;
`;

const BadgeJunk = styled.div.attrs<BadgeJunkProps>((props) => ({
  type: props.type,
  visible: props.visible,
}))<BadgeJunkProps>`
  display: ${({ visible }) => (visible ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  font-weight: 700;
  border: 1px solid black;
  border-radius: 4px;
  height: 24px;
  font-size: 12px;
  line-height: 16px;
  padding: 4px 8px;
  margin: 0 12px 0 4px;
  pointer: cusor;

  img {
    margin-right: 2px;
  }

  ${({ type }) => {
    if (type === 'junk') {
      return `
        border-color: #F5931B;
        color: #F5931B;
      `;
    }

    if (type === 'spam') {
      return `
        border-color: #EE4A49;
        color: #EE4A49;
      `;
    }

    return '';
  }}
`;

const UnstyledButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: inherit;
  font: inherit;
`;

const IconStyle = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover > svg > path {
    stroke: #00ab6b;
  }
`;

export {
  OptionItemContainer,
  FlagPro,
  HeaderContent,
  TextHeader,
  ContentWrapper,
  ImgWrapper,
  ImgModal,
  ImgContent,
  CommentContainer,
  TextContainer,
  ImgContainer,
  FooterContainer,
  StreamBoxContainer,
  Title,
  RepostBoxContainer,
  NotifText,
  IconStyle,
  StreamOptionContainer,
  StreamOptionDivider,
  YoutubeWrapper,
  RepostImageContainer,
  FollowingActivityAvatar,
  FollowingActivityAvatarItem,
  BadgeJunkWrapper,
  BadgeJunk,
  UnstyledButton,
};
